"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.interleave = interleave;
exports.default = void 0;

var _iterable = require("../../internal/iterable");

var _buffer = _interopRequireDefault(require("./internal/buffer"));

var _canTakeAny = _interopRequireDefault(require("./internal/can-take-any"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function* interleave(sources, generateInterleaved, options) {
  const buffers = sources.map((iterable, i) => new _buffer.default((0, _iterable.ensureIterable)(iterable)[Symbol.iterator](), i));

  try {
    const canTakeAny = (0, _canTakeAny.default)(buffers);
    yield* options !== undefined ? generateInterleaved(options, canTakeAny, ...buffers) : generateInterleaved(canTakeAny, ...buffers);
  } finally {
    for (const buffer of buffers) {
      if (buffer.canTake() && typeof buffer._iterator.return === 'function') {
        buffer._iterator.return();
      }
    }
  }
}

var _default = (0, _iterable.iterableCurry)(interleave, {
  variadic: true,
  optionalArgsAtEnd: true,
  minArgs: 1,
  maxArgs: 2
});

exports.default = _default;